export default {
  'email': null,
  'password': null,
  'location_id': null,
  'user_role': null,
};
